/**
 * Header component
 * @author Carlos Romera <cromera@adasasistemas.com>
 */

// Library
import React, { useContext, useMemo, useState } from 'react';
// Assets

// Context
import { NotificationsContext, ScreenSizeContext, UserTypeContext } from '@context';
import { Button, NavLink } from '@general';
import { Account, WaterIQLogo } from '@public';
// Service
import { msalService } from '@services';
// Component
import { DropdownMenu, MessageIcon } from '@specific';
import { WaterIQUserType } from '@types';
import { useLogout } from '@utils';

// CSS Style for this module
import styles from './header.module.scss';

export const Header = () => {
	// Context
	const { selectedUserType } = useContext(UserTypeContext);
	const { unreadNumber } = useContext(NotificationsContext);
	const { isSmallDT } = useContext(ScreenSizeContext);
	// State
	const [menuOpen, setOpen] = useState(false);
	// Memo
	const displayMessageIcon = useMemo(
		() => msalService.isValidAccount() && selectedUserType != WaterIQUserType.DQP,
		[selectedUserType],
	);
	const displayAccountIcon = useMemo(() => msalService.isValidAccount(), []);
	const displayLogOutButton = useMemo(() => {
		const isRegistrationPageActive = msalService.isValidUnlinkedAccount();
		const isClosedAccountPageActive =
			!msalService.isValidAccount() &&
			!msalService.isValidUnlinkedAccount() &&
			msalService.isClosedAccount();
		return isRegistrationPageActive || isClosedAccountPageActive;
	}, []);
	// Others
	const logout = useLogout();

	const account = () => {
		return (
			displayAccountIcon && (
				<>
					<DropdownMenu
						isOpen={menuOpen}
						isForMobile={isSmallDT}
						closeMenu={() => {
							setOpen(false);
						}}
					>
						<Button
							customStyles={styles.accountButton}
							aria-label="user account"
							onClick={() => setOpen(prev => !prev)}
						>
							<Account customStyles={styles.accountIcon} />
						</Button>
					</DropdownMenu>
				</>
			)
		);
	};

	const logOutButton = () => {
		return (
			displayLogOutButton && (
				<>
					<Button
						type="primary"
						size="small"
						customStyles={styles.logOutButton}
						aria-label="Logout-header"
						onClick={logout}
					>
						Log out
					</Button>
				</>
			)
		);
	};

	return (
		<header className={styles.container}>
			<nav className={styles.wrapper}>
				<NavLink href={'/'}>
					<div className={styles.logo}>
						<WaterIQLogo customStyles={styles.headerLogo} />
						<div className={styles.logoName}>WaterIQ</div>
					</div>
				</NavLink>
				<span className={styles.headerButtons}>
					{displayMessageIcon && <MessageIcon unreadNumber={unreadNumber} />}
					{account()}
					{logOutButton()}
				</span>
			</nav>
		</header>
	);
};
